import { ReactComponent as IconClose } from '@/assets/svgs/icon-close.svg';
import { ReactComponent as IconTnc } from '@/assets/svgs/icon-info.svg';
import { ReactComponent as IconTick } from '@/assets/svgs/tick.svg';
import Button from '@/components/Button/index';
import CardConfigure from '@/componentsDS/Modal/CardConfigure';
import Modal from '@/componentsDS/Modal/Modal';
import { ToastContext } from '@/context/toast/index';
import useModal from '@/hooks/use-modal';
import useTnc from '@/hooks/use-tnc';
import { useNavigate } from '@/lib/router-dom';
import { logout } from '@/redux/actions/auth.js';
import API_PROFILE from '@/services/api/profile.js';
import rem from '@/utils/rem';
import classname from 'classnames';
import { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDexConfig } from "@/utils/get-dex-config";
import { getEnvAndDex } from "@/utils/get-env-and-dex";

const Tnc = ({tncStatus, setTncStatus, profile, setProfile}) => {

	const dispatch = useDispatch()
	const { goTo } = useNavigate();

	const user = useSelector(state => state.auth.user)
	const { addToastMessage } = useContext(ToastContext)

	const { tnc, fetch: fetchTnc, error: tncError, accept, } = useTnc()

	const { visible: visibleTnc, show: showTnc, hide: hideTnc } = useModal()
	const { visible: visibleTncDecline, show: showTncDecline, hide: hideTncDecline } = useModal()

	const [tncChecked, setTncChecked] = useState(false)
	const [loadingAccept, setLoadingAccept] = useState(false)

	const { dex } = getEnvAndDex();
	const { dexName } = getDexConfig(dex);



	useEffect( async () => {
		await fetchTnc();
		function getProfileData() {
			if (profile) {
				let tAndCStatus = profile?.tncStatus;
				setTncStatus(tAndCStatus)
			}
		}
		getProfileData()
	}, []);


	useEffect(() => {
		if (!tncStatus) {
			showTnc()
			return
		}
		hideTnc()
	}, [tncStatus])


	function handledCheckedTnc(){
		setTncChecked(!tncChecked)
	}

	async function acceptTnC(){

		setLoadingAccept(true)

		const payload = {
			"email": `${user.email}`,
			"userId" : `${user.id}`,
			"accept" : true
		};

		const [error, result] = await accept(payload)

		if (error) {
			hideTnc()
			return addToastMessage('TNC Accept has error', 'error')
		}

		setLoadingAccept(false);
		hideTnc();

		const [errorProfile, responseProfile] = await API_PROFILE.getProfile(user.id)
		if(errorProfile){
			return addToastMessage("Error in getting profile", 'error')
		}
		// setShowWhatsNew(true); //show new features;
		setTncStatus(responseProfile?.tncStatus ? true : false);
		sessionStorage.setItem('profile', JSON.stringify(responseProfile))
		setProfile(responseProfile)
	}

	const tncCheckBoxClass = classname({
		"tnc-modal__agree-checkbox": true,
		"tnc-modal__agree-checkbox--active": tncChecked,
	})

	return (
		<>
			<Modal visible={visibleTnc} variant='large' close={showTncDecline}>
				<CardConfigure>
					<CardConfigure.Header>
						<CardConfigure.Header.Title>
							<div className="card-configure__header__left">
								<div className="card-configure__title">
									<div className="card-configure__title__left">
										<div className='tnc-modal__icon'><IconTnc /></div>
									</div>
									<div className="card-configure__title__right">
										<div className="card-configure__title__right__top">
											Terms and Conditions
										</div>
									</div>
								</div>
							</div>
						</CardConfigure.Header.Title>
					</CardConfigure.Header>
					<CardConfigure.Body>
						<CardConfigure.Body.Col>
							<div className="card-configure__sub-header">
								<div className="tnc-modal__agree-action">
									<div className="tnc-modal__agree-header">Please accept the Terms and Conditions to access {dexName} information.</div>
								</div>
							</div>
							<div className="tnc-modal__tcn">
								<div className="tnc-modal__tnc-content" dangerouslySetInnerHTML={{ __html: tnc }}>
								</div>
								<div className="tnc-modal__agree-content">
									<label className='tnc-modal__checkbox'>
										<input className='tnc-modal__checkbox-input'
											type="checkbox"
											checked={tncChecked}
											onChange={handledCheckedTnc}
										/>
										<div className={tncCheckBoxClass}>{tncChecked? <IconTick /> : null}</div>
										I accept the terms and conditions of accessing SGTraDex's information
									</label>
								</div>
							</div>
						</CardConfigure.Body.Col>
					</CardConfigure.Body>
					<CardConfigure.Footer>
						<CardConfigure.Footer.Right>
							<Button full maxWidth="100" submit={()=>acceptTnC()} disabled={(!tncChecked || loadingAccept)} text="Continue" loading={loadingAccept}/>
						</CardConfigure.Footer.Right>
					</CardConfigure.Footer>
				</CardConfigure>
			</Modal>
			<Modal visible={visibleTncDecline } variant='medium' close={hideTncDecline}>
				<CardConfigure >
					<CardConfigure.Header>
						<CardConfigure.Header.Title>
							<div className="card-configure__header__left">
								<div className="card-configure__title">
									<div className="card-configure__title__right">
										<div className="card-configure__title__right__top">
											Decline Terms and Conditions
										</div>
									</div>
								</div>
							</div>
						</CardConfigure.Header.Title>
					</CardConfigure.Header>
					<CardConfigure.Body>
						<CardConfigure.Body.Col>
							<div className='tcn-modal__decline-text'>
								You need to accept the Terms & Conditions to use this application. You will be automatically logged out if you do not wish to proceed. <br /><br /> You can still login to accept the Terms & Conditions in the future.
							</div>
						</CardConfigure.Body.Col>
					</CardConfigure.Body>
					<CardConfigure.Footer>
						<CardConfigure.Footer.Right>
							<Button full text="Log Out" submit={()=>{
								dispatch(logout(goTo))
							}}/>
						</CardConfigure.Footer.Right>
					</CardConfigure.Footer>
				</CardConfigure>
			</Modal>
		</>

	)
}

export default Tnc
